export default __webpack_public_path__ + "static/media/hefeos_logo_01.e4bcfb0f.svg";